<div class="current-slip-core-desktop mobile">
  <div class="container">
    <ng-container *ngIf="isMobileView === false">
      <ng-container>
        <div class="header bet-slip-header {{ this._UserHelper.isSignedIn ? ' double' : '' }}">
          <div class="header-item sl-round round-tl-5 round-tr-5" (click)="slipHeaderChangeTab(1)" [ngClass]="{ passive: this._UiHelper.currentSlipHeaderTabSelected != 1 }">
            <div class="header-text whiteText">{{ 'b3000_Bets_slip' | t }}</div>
            <div class="header-count">
              <div class="count-box">{{ this._DataHelper.currentSlipData.length }}</div>
            </div>
          </div>
          <ng-container [ngSwitch]="['terminalPeru'] | getProductName">
            <ng-container *ngSwitchCase="'terminalPeru'">
              <div *ngIf="this._UserHelper.isSignedIn" class="header-item sl-round round-tl-5 round-tr-5 passive">
                <div class="header-text whiteText">{{ 'MyBets' | t }}</div>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div
                *ngIf="this._UserHelper.isSignedIn"
                class="header-item sl-round round-tl-5 round-tr-5"
                (click)="slipHeaderChangeTab(2)"
                [ngClass]="{ passive: this._UiHelper.currentSlipHeaderTabSelected != 2 }">
                <div class="header-text whiteText">{{ 'MyBets' | t }}</div>
                <div class="header-count">
                  <div class="count-box">{{ this._DataHelper.cashoutSlipsList.length }}</div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <div class="content bg-transparent">
      <div class="bet-slip-container">
        <!--- Bet Slip currentSlipHeaderTabSelected = 1 --->
        <ng-container *ngIf="this._UiHelper.currentSlipHeaderTabSelected == 1">
          <div class="mobile-page-header" *ngIf="isMobileView === true">
            <div class="left-side">
              <span>{{ 'b3000_bet_slip' | t }}</span>
              <span>({{ this._DataHelper.currentSlipData.length }})</span>
              <div (click)="removeAll()">
                <image-loader-utils url="trash" extraClasses="left-side-trash"></image-loader-utils>
              </div>
            </div>
            <div class="right-side" (click)="CurrentSlipBack()">
              <image-loader-utils url="up-arrow" extraClasses="arrow-icon down icon-lg"></image-loader-utils>
            </div>
          </div>

          <div class="empty text sl-round round-bl-5 round-br-5" *ngIf="this._DataHelper.currentSlipData.length == 0 && !isMobileView">
            {{ 'b3000_current_slip_core_text_1' | t }}
          </div>

          <ng-container *ngIf="this._DataHelper.currentSlipData.length > 0">
            <!-- (1 - Desktop) Mobile ve Desktop ayrı yerlerde olduğu için iki tane var. css ile yapmak zor.-->
            <div *ngIf="isMobileView === false" class="bet-slip-tab-row sl-round round-bl-5 round-br-5">
              <div class="tab-item" [ngClass]="{ active: this._UiHelper.currentSlipTabSelected == 0 }" (click)="changeBetSlipTab(0)">
                {{ 'Single' | t }}
              </div>
              <div
                class="tab-item active"
                [ngClass]="{ active: this._UiHelper.currentSlipTabSelected == 1, disabled: this._DataHelper.currentSlipData.length < 2 }"
                (click)="changeBetSlipTab(1)">
                {{ 'Multiple' | t }}
              </div>
              <div
                class="tab-item"
                [ngClass]="{ active: this._UiHelper.currentSlipTabSelected == 2, disabled: this._DataHelper.currentSlipData.length < 2 }"
                (click)="changeBetSlipTab(2)">
                {{ 'System' | t }}
              </div>
            </div>

            <!-- Ticket list -->
            <div class="tickets">
              <div class="ticket-item sl-round round-5 card" *ngFor="let slipEvent of this._DataHelper.currentSlipData.reverse() | groupByEventName; first as isFirst">
                <div class="match-row">
                  <div class="banko" *ngIf="this._UiHelper.currentSlipTabSelected == 2">
                    <div class="btn-banko" [ngClass]="slipEvent.Banko == true ? 'active' : ''" (click)="changeSelectedSlipCurrent(slipEvent)">B</div>
                  </div>
                  <div class="match-info">
                    <div class="team-name">{{ slipEvent.HomeTeam }}</div>
                    <div class="team-name">{{ slipEvent.AwayTeam }}</div>
                  </div>
                  <div class="match-score" *ngIf="!getLiveEvent(slipEvent.MatchId)">
                    <div class="score-box"></div>
                    <div class="score-box now">
                      <div class="text">
                        {{
                          (slipEvent.EventDateLong | dateFormat : 'dd-MM') == (this.today | dateFormat : 'dd-MM') ? ('today' | t) : (slipEvent.EventDateLong | dateFormat : 'dd.MM')
                        }}
                      </div>
                      <div class="text">
                        <ng-container [ngSwitch]="['wettarena'] | getProductName">
                          <ng-container *ngSwitchCase="'wettarena'">
                            {{ slipEvent.EventDateLong | dateFormat : 'H:mm' }}
                          </ng-container>
                          <ng-container *ngSwitchDefault>
                            {{ slipEvent.EventDateLong | dateFormat : 'H:mm' }}
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="match-score" *ngIf="getLiveEvent(slipEvent.MatchId) as eventObj">
                    <div class="score-box">
                      {{ eventObj.TimeStatu != 3 ? (eventObj.MatchTime != null ? eventObj.MatchTime + "'" : '') : eventObj.TimeStatuColor.trim() }}
                    </div>
                    <div class="score-box now">
                      <span>
                        {{ eventObj.Score != null && eventObj.Score !== '' ? eventObj.Score.split(':')[0] : '' }}
                      </span>
                      <span>
                        {{ eventObj.Score != null && eventObj.Score !== '' ? eventObj.Score.split(':')[1].trim() : '' }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="odd-box">
                  <div class="odd-row" [ngClass]="slipCurrent.Visibility === 'hidden' ? 'odd-locked' : ''" *ngFor="let slipCurrent of slipEvent?.eEvents">
                    <image-loader-utils url="fa-lock" extraClasses="odd-locked-icon lock-icon colorG"></image-loader-utils>
                    <div class="odd">
                      <div class="left">
                        {{ slipCurrent.OddsType }}
                        {{ slipCurrent.SpecialBetValue }}&nbsp;:&nbsp;<b>{{ slipCurrent.OutCome }}</b>
                      </div>
                      <div class="mid"></div>
                      <div
                        class="right"
                        [ngClass]="{
                          'odd-up': !this._UiHelper.checkboxAcceptOdds && slipCurrent.FirstOddValue1 < slipCurrent.OddValue1,
                          'odd-down': !this._UiHelper.checkboxAcceptOdds && slipCurrent.FirstOddValue1 > slipCurrent.OddValue1
                        }">
                        {{ slipCurrent.Visibility === 'hidden' ? '-' : (slipCurrent.OddValue1 | number : '1.2-2') }}
                      </div>
                    </div>

                    <div class="close" (click)="removeOdd(slipCurrent.OddId1)">
                      <image-loader-utils url="times-circle" extraClasses="times-circle-icon"></image-loader-utils>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- (2 - Mobile) Mobile ve Desktop ayrı yerlerde olduğu için iki tane var. css ile yapmak zor.-->
            <div *ngIf="isMobileView === true" class="bet-slip-tab-row">
              <div class="tab-item" [ngClass]="{ active: this._UiHelper.currentSlipTabSelected == 0 }" (click)="changeBetSlipTab(0)">
                {{ 'Single' | t }}
              </div>
              <div
                class="tab-item active"
                [ngClass]="{ active: this._UiHelper.currentSlipTabSelected == 1, disabled: this._DataHelper.currentSlipData.length < 2 }"
                (click)="changeBetSlipTab(1)">
                {{ 'Multiple' | t }}
              </div>
              <div
                class="tab-item"
                [ngClass]="{ active: this._UiHelper.currentSlipTabSelected == 2, disabled: this._DataHelper.currentSlipData.length < 2 }"
                (click)="changeBetSlipTab(2)">
                {{ 'System' | t }}
              </div>
            </div>

            <!-- System selection -->
            <div class="system-item-container" *ngIf="this._UiHelper.currentSlipTabSelected == 2">
              <div class="system-title-row system-row">
                <div class="title">{{ 'b3000_Systems' | t }}</div>
                <div class="system-info" *ngIf="!this._DataHelper.currentSlipInfo.isCheckIsSystem">
                  {{ 'b3000_current_slip_core_text_2' | t }}
                </div>
              </div>
              <ng-container *ngFor="let systemSlip of this._DataHelper.currentSlipSystemInfo; let i = index; trackBy: trackByFnSystemCombinations">
                <div class="system-row" [ngClass]="{ hide: systemSlip.combination > 330 }">
                  <input
                    type="checkbox"
                    id="system_checkbox_{{ i + 1 }}"
                    name="system_checkbox_{{ i + 1 }}"
                    (click)="changeAmount($event, systemSlip.index, systemSlip.combination)"
                    [checked]="this._DataHelper.currentSlipSystemSelection.includes(systemSlip.index + 1 + '_' + systemSlip.combination)" />
                  <label for="system_checkbox_{{ i + 1 }}">
                    {{ 'System' | t }} {{ i + 1 }}/{{ this._DataHelper.currentSlipSystemInfo.length }} (<strong>{{ systemSlip.combination }} {{ 'Bets' | t }}</strong
                    >)
                  </label>
                </div>
              </ng-container>
            </div>

            <div *ngIf="isMobileView === false" class="bet-slip-remove-all">
              <div (click)="removeAll()">
                <image-loader-utils url="trash" extraClasses="left-side-trash"></image-loader-utils>
              </div>
              <div (click)="removeAll()" class="btn-remove-all">{{ 'Remove_All' | t }}</div>
            </div>
            <!-- Mobile accept change and max odd area -->
            <div class="accept-change-row" *ngIf="isMobileView === true">
              <div class="left-side">
                <input type="checkbox" id="accept-odds-mobile" (change)="this._UiHelper.setAcceptOdds($event)" [(ngModel)]="this._UiHelper.checkboxAcceptOdds" />
                <label for="accept-odds-mobile">
                  {{ 'b3000_Accept_odds_change' | t }}
                </label>
              </div>
              <div class="right-side">
                <span class="desc">{{ 'b3000_Max_Odds' | t }} :</span>
                <span class="value">{{ this._DataHelper.currentSlipInfo.currentTotalRate }}</span>
              </div>
            </div>

            <div *ngIf="isMobileView === false" class="slip-amount-container sl-round round-tl-5 round-tr-5 card">
              <div class="slip-amount-row two-col">
                <div class="slip-amount-input">
                  <p class="input-row">
                    {{ _UserHelper.customerUser?.Symbol }}
                    <input
                      placeholder="0"
                      (blur)="onBlurTotalStake($event)"
                      (keyup)="changeTotalStake($event)"
                      [value]="this._DataHelper.currentSlipInfo.currentslip_totalStake"
                      class="slip-amount-borderless-input" />
                  </p>
                  <span class="slip-amount-subtext">{{ 'ToPay' | t }}</span>
                </div>
                <div class="slip-amount-gain">
                  <p class="subtext">{{ 'Min_Possible_winnings' | t }}</p>
                  <p class="pg-amount">{{ this._DataHelper.currentSlipInfo.maxGain }} {{ _UserHelper.customerUser?.Symbol }}</p>
                </div>
              </div>

              <div class="slip-amount-row" *ngIf="tax !== ''">
                <div class="left">{{ 'b3000_Fee' | t }}</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.tax }} {{ _UserHelper.customerUser?.Symbol }}</div>
              </div>

              <div class="slip-amount-row">
                <div class="left">{{ 'Amount_Per_Bet' | t }} ({{ this._DataHelper.currentSlipInfo.numberOfBets }} {{ 'Bets' | t }} )</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.amountPerBet }} {{ _UserHelper.customerUser?.Symbol }}</div>
              </div>

              <div class="slip-amount-row">
                <div class="left">{{ 'Number_Of_Bets' | t }}</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.numberOfBets }}</div>
              </div>

              <div class="slip-amount-row">
                <div class="left">{{ 'Total_Rate' | t }}</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.totalRate }} {{ _UserHelper.customerUser?.Symbol }}</div>
              </div>
              <div class="slip-amount-row">
                <div class="left">{{ 'Max_Possible_winnings' | t }}</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.maxGain }} {{ _UserHelper.customerUser?.Symbol }}</div>
              </div>
              <div class="slip-amount-row">
                <div class="left">{{ 'Min_Possible_winnings' | t }}</div>
                <div class="right">{{ this._DataHelper.currentSlipInfo.minGain }} {{ _UserHelper.customerUser?.Symbol }}</div>
              </div>
              <div class="lugas-error-message" *ngIf="this._UiHelper.isLugasErrorActive">
                <div class="icon">
                  <image-loader-utils url="info-circle" extraClasses="lugassvg"></image-loader-utils>
                </div>
                <ng-container [ngSwitch]="['wettarena'] | getProductName">
                  <ng-container *ngSwitchCase="'wettarena'">
                    <div class="lugas-error-message-row">
                      {{ 'lugas_error_message_wa' | t }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'b3000'">
                    <div class="lugas-error-message-row">
                      {{ 'lugas_error_message_b3000' | t }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="lugas-error-message-row">
                      {{ 'lugas_error_message_b3000' | t }}
                    </div>
                  </ng-container>
                </ng-container>

                <!-- <div class="lugas-error-message-row">
                 {{'lugas_error_message_2' | t}}
                </div> -->
              </div>
              <div class="lugas-error-message" *ngIf="this._UiHelper.isLugasError5minute">
                <div class="icon">
                  <span class="lugassvg" [inlineSVG]="'angular/dist/assets/media/b3000/info-circle.svg'"></span>
                </div>
                <div class="lugas-error-message-row">
                  {{ 'lugas_error_message_5_minute' | t }}
                </div>
              </div>
            </div>
            <div *ngIf="isMobileView === true" class="slip-amount-container">
              <ng-container *ngIf="keyboardIsOpen">
                <div class="keyboard-total-stake-row">
                  <div class="left-side">{{ 'Total_Stake' | t }}</div>
                  <div class="right-side">
                    <div class="keyboard-total-stake-input">
                      <div class="keyboard-total-stake">
                        {{ this._DataHelper.currentSlipInfo.currentslip_totalStake }}
                      </div>
                      <div class="keyboard-total-stake-currency">
                        {{ _UserHelper.customerUser?.Symbol }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="slip-amount-keyboard">
                  <div class="left-side">
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(1)">1</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(2)">2</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(3)">3</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(4)">4</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(5)">5</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(6)">6</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(7)">7</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(8)">8</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(9)">9</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000('.')">.</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(0)">0</div>
                    <div class="keyboard-button" (click)="changeStakeInKeyboardB3000(0, 'backspace')">
                      <image-loader-utils url="back"></image-loader-utils>
                    </div>
                  </div>
                  <div class="right-side">
                    <div class="keyboard-button right" (click)="changeStakeInKeyboardB3000(0, '+10')">+ 10</div>
                    <div class="keyboard-button right" (click)="changeStakeInKeyboardB3000(0, '+50')">+ 50</div>
                    <div class="keyboard-button right" (click)="changeStakeInKeyboardB3000(1, 'C')">C</div>
                    <div class="keyboard-button right" (click)="changeKeyboardState(false)">OK</div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!keyboardIsOpen">
                <div class="total-stake-result-row">
                  <div class="left-side">
                    <div class="total-stake-result" (click)="changeKeyboardState(true)">
                      <div class="value">
                        {{ this._DataHelper.currentSlipInfo.currentslip_totalStake?.toFixed(2) }}
                        {{ _UserHelper.customerUser?.Symbol }}
                      </div>
                      <div class="desc">{{ 'Total_Stake' | t }}</div>
                    </div>
                  </div>
                  <!-- 0 - 1 -  Is Single or Multiple -->

                  <div class="right-side" *ngIf="this._UiHelper.currentSlipTabSelected != 2">
                    <div class="possible-winning">
                      <div class="value">{{ this._DataHelper.currentSlipInfo.maxGain }} {{ _UserHelper.customerUser?.Symbol }}</div>
                      <div class="desc">{{ 'Possible_winnings' | t }}</div>
                    </div>
                  </div>

                  <!-- 2 -  Is System -->
                  <div class="right-side-winning" *ngIf="this._UiHelper.currentSlipTabSelected == 2">
                    <div class="winning">
                      <div class="desc">{{ 'Max_Possible_winnings' | t }}</div>
                      <div class="value">{{ this._DataHelper.currentSlipInfo.maxGain }} {{ _UserHelper.customerUser?.Symbol }}</div>
                    </div>
                    <div class="winning">
                      <div class="desc">{{ 'Min_Possible_winnings' | t }}</div>

                      <div class="value">{{ this._DataHelper.currentSlipInfo.minGain }} {{ _UserHelper.customerUser?.Symbol }}</div>
                    </div>
                  </div>
                </div>

                <div class="slip-amount-row" *ngIf="this._DataHelper.currentSlipInfo.tax !== ''">
                  <div class="left">{{ 'b3000_Fee' | t }}</div>
                  <div class="right">
                    {{ getNumber(this._DataHelper.currentSlipInfo.tax) | number : '1.2-2' }}
                    {{ _UserHelper.customerUser?.Symbol }}
                  </div>
                </div>
                <div class="slip-amount-row">
                  <div class="left">{{ 'Amount_Per_Bet' | t }} ({{ this._DataHelper.currentSlipInfo.numberOfBets }} {{ 'Bets' | t }} )</div>
                  <div class="right">{{ this._DataHelper.currentSlipInfo.amountPerBet }} {{ _UserHelper.customerUser?.Symbol }}</div>
                </div>
              </ng-container>
              <div class="lugas-error-message" *ngIf="this._UiHelper.isLugasErrorActive">
                <div class="icon">
                  <span class="lugassvg" [inlineSVG]="'angular/dist/assets/media/b3000/info-circle.svg'"></span>
                </div>
                <ng-container [ngSwitch]="['wettarena'] | getProductName">
                  <ng-container *ngSwitchCase="'wettarena'">
                    <div class="lugas-error-message-row">
                      {{ 'lugas_error_message_wa' | t }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'b3000'">
                    <div class="lugas-error-message-row">
                      {{ 'lugas_error_message_b3000' | t }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="lugas-error-message-row">
                      {{ 'lugas_error_message_b3000' | t }}
                    </div>
                  </ng-container>
                </ng-container>

                <!-- <div class="lugas-error-message-row">
                 {{'lugas_error_message_2' | t}}
                </div> -->
              </div>
              <div class="lugas-error-message" *ngIf="this._UiHelper.isLugasError5minute">
                <div class="icon">
                  <image-loader-utils url="info-circle" extraClasses="lugassvg"></image-loader-utils>
                </div>
                <div class="lugas-error-message-row">
                  {{ 'lugas_error_message_5_minute' | t }}
                </div>
                <!-- <div class="lugas-error-message-row">
                 {{'lugas_error_message_2' | t}}
                </div> -->
              </div>
            </div>

            <div class="slip-amount-bottom sl-round round-bl-5 round-br-5 card">
              <div *ngIf="isMobileView === false" class="accept-odds">
                <input type="checkbox" id="accept-odds" (change)="this._UiHelper.setAcceptOdds($event)" [(ngModel)]="this._UiHelper.checkboxAcceptOdds" />
                <label for="accept-odds">{{ 'accept_change_of_odds' | t }}</label>
              </div>

              <ng-container *ngIf="this._UiHelper.placeBetIsActive">
                <ng-container [ngSwitch]="['b500', 'b3000'] | getProductName">
                  <ng-container *ngSwitchCase="'b500'">
                    <div class="curent-slip-core-button-row">
                      <button class="submit-ok-button" (click)="placeBet()" mat-stroked-button>
                        {{ 'Confirm' | t }}
                      </button>
                      <button class="cancel-button" (click)="placeBetActive(false)" mat-stroked-button>
                        {{ 'Modify' | t }}
                      </button>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'b3000'">
                    <div
                      class="btn big-size-place wallet-shop-no-bet"
                      *ngIf="this._UserHelper.isSignedIn && this._DataHelper.selectedWallet.BranchType === 0; else confirmContainer">
                      {{ 'No_Bet' | t }}
                    </div>

                    <ng-template #confirmContainer>
                      <div class="curent-slip-core-button-row">
                        <button class="submit-ok-button" (click)="placeBet()" mat-stroked-button>
                          {{ 'Confirm' | t }}
                        </button>
                        <button class="cancel-button" (click)="placeBetActive(false)" mat-stroked-button>
                          {{ 'Modify' | t }}
                        </button>
                      </div>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="curent-slip-core-button-row">
                      <button class="submit-ok-button" (click)="placeBet()" mat-stroked-button>
                        {{ 'Confirm' | t }}
                      </button>
                      <button class="cancel-button" (click)="placeBetActive(false)" mat-stroked-button>
                        {{ 'Modify' | t }}
                      </button>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!this._UiHelper.placeBetIsActive">
                <div class="submit-bet-row-container">
                  <ng-container [ngSwitch]="['b3000'] | getProductName">
                    <ng-container *ngSwitchCase="'b3000'"></ng-container>
                    <ng-container *ngSwitchDefault>
                      <div class="submit-bet-row-item-barcode">
                        <div class="slip-submit-barcode" (click)="placeBetTemp()">
                          <image-loader-utils url="barcode" extraClasses="barcode-icon white-color"></image-loader-utils>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container [ngSwitch]="['betarena', 'b3000'] | getProductName">
                    <ng-container *ngSwitchCase="'betarena'"></ng-container>
                    <ng-container *ngSwitchCase="'b3000'">
                      <div class="submit-bet-row-item">
                        <div
                          class="btn colored bold big-size-place"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            (!this._DataHelper.currentSlipInfo.isCheckIsSystem || this._UiHelper.currentSlipTabSelected != 2 || !this._DataHelper.currentSlipInfo.isMultiWaySystem)
                          "
                          (click)="placeBetActive(true)">
                          {{ 'Submit_Bet' | t }}
                        </div>
                        <div
                          class="btn colored bold no-cashout-button two-line-info"
                          *ngIf="
                            (this._UiHelper.checkboxAcceptOdds || !this._DataHelper.currentSlipInfo.oddIsChange) &&
                            this._DataHelper.currentSlipInfo.isMultiWaySystem &&
                            this._DataHelper.currentSlipInfo.isCheckIsSystem &&
                            this._UiHelper.currentSlipTabSelected == 2
                          "
                          (click)="placeBetActive(true)">
                          {{ 'b3000_accept_odds_button_text_5' | t }}
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <div class="submit-bet-row-item">
                        <div class="btn colored bold big-size-place" (click)="placeBetActive(true)">
                          {{ 'Submit_Bet' | t }}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <div
                    class="current-slip-submit-button odd-change"
                    *ngIf="!this._UiHelper.checkboxAcceptOdds && this._DataHelper.currentSlipInfo.oddIsChange"
                    (click)="placeBetActive(true)">
                    <div class="text1">
                      {{ 'b3000_accept_odds_button_text_1' | t }}
                    </div>
                    <div class="text2">
                      {{ 'b3000_accept_odds_button_text_2' | t }}
                    </div>
                  </div>
                </div>
                <!-- No Cashout & system & multiway -->
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="this._DataHelper.currentSlipData.length == 0 && isMobileView">
            <div class="bet-slip-mobile-popular-league">
              <div class="bet-slip-empty-container">
                <div class="bet-slip-empty-text">
                  {{ 'b3000_current_slip_core_text_4' | t }}
                </div>
                <image-loader-utils url="bet-slip" extraClasses="bet-slip-empty-container-svg"></image-loader-utils>
              </div>
              {{ 'b3000_Popular_leagues' | t }}
              <ng-container *ngFor="let league of topLeaguesData">
                <div class="popular-league-button" (click)="getMatch(league)">
                  <image-loader-utils url="league-icon" extraClasses="svg popular-leagues-icon"></image-loader-utils>
                  <div class="">{{ league.TournamentName }}</div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
        <!--- My Bets - Cashout - currentSlipHeaderTabSelected = 2 --->
        <ng-container *ngIf="'isNewCashout' | getEnv; else elseBlock">
          <ng-container *ngIf="!isMobileView && this._UiHelper.currentSlipHeaderTabSelected == 2">
            <cashout-new></cashout-new>
          </ng-container>
        </ng-container>
        <ng-template #elseBlock>
          <ng-container *ngIf="!isMobileView && this._UiHelper.currentSlipHeaderTabSelected == 2">
            <cashout-component (cashoutLengthListener)="cashoutLengthListener($event)"></cashout-component>
          </ng-container>
        </ng-template>
      </div>
    </div>

    <!-- Lock area -->
    <ng-container [ngSwitch]="['cangobet', 'b500'] | getProductName">
      <ng-container *ngSwitchCase="'cangobet'"> </ng-container>
      <ng-container *ngSwitchCase="'b500'"> </ng-container>

      <ng-container *ngSwitchDefault>
        <div class="lock-button-main-container text sl-round round-5" *ngIf="this._UserHelper.isSignedIn && this.isMobileView === false">
          <div class="lock-info-text">{{ 'b3000_current_slip_core_text_3' | t }}</div>
          <div class="lock-button-box">
            <div id="accountLockButton24v2" mat-flat-button class="lock-button">
              {{ '24h_Lock' | t }}
            </div>
            <section class="account-lock-section" *ngIf="progressValue > 0">
              <ng-container *ngIf="holdSeconds != 0">
                <mat-progress-bar class="account-lock-progress-bar" mode="determinate" value="{{ this.progressValue }}"></mat-progress-bar>
                <div class="progress-bar-text">{{ holdSeconds }}</div>
              </ng-container>
            </section>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
